import { render, staticRenderFns } from "./setGroupAcls.vue?vue&type=template&id=af348a90"
import script from "./setGroupAcls.vue?vue&type=script&lang=js"
export * from "./setGroupAcls.vue?vue&type=script&lang=js"
import style0 from "./setGroupAcls.vue?vue&type=style&index=0&id=af348a90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports